// extracted by mini-css-extract-plugin
export default {"statucBlock":"Failed_statucBlock__Z8OAx","paymentInfo":"Failed_paymentInfo__llhSh","infoBlock":"Failed_infoBlock__RSGoU"};